// import React from "react";
// import "./DynamicRadio.css";
// const DynamicRadioGroup = ({ label, name, options = [], value, onChange, direction = "row", disabled = false, handleError, required }) => {
//   return (
//     <div className={`form-group formgroupcss`}>
//       <div className="radio-wrapper">
//         {label && (
//           <div className="form-label">
//             {label}
//             {required && <span className="text-danger ml-1">*</span>}
//           </div>
//         )}
//         <div className={`radio-group m-0 ${direction === "column" ? "column" : ""} row`}>
//           {options?.map((option) => {
//             return (
//               <label key={option.value} className="radio-option col-md-3">
//                 <input
//                   type="radio"
//                   name={name}
//                   value={option.value}
//                   className="inputStyle"
//                   checked={value === option.value}
//                   onChange={(e) => {
//                     console.log("genderradioChange", e.target.value);
//                     onChange(e);
//                   }}
//                   disabled={disabled}
//                 />
//                 <span>{option.label}</span>
//               </label>
//             );
//           })}
//         </div>
//       </div>
//       {handleError && handleError(name)}
//     </div>
//   );
// };

// export default DynamicRadioGroup;

import React from "react";
import "./DynamicRadio.css";

const DynamicRadioGroup = ({ label, name, options = [], value, onChange, disabled = false, handleError, required }) => {
  return (
    <div className="form-group formgroupcss mb-1">
      {label && (
        <div className="form-label mb-1 font-weight-bold">
          {label}
          {required && <span className="text-danger ml-1">*</span>}
        </div>
      )}

      <div className="radio-card  rounded ">
        <div className="d-flex flex-wrap align-items-center gap-4">
          {options?.map((option) => (
            <label key={option.value} className="d-flex align-items-center radio-option">
              <input type="radio" name={name} value={option.value} className="radio-input me-2" checked={value === option.value} onChange={onChange} disabled={disabled} />
              <span className="radio-label">{option.label}</span>
            </label>
          ))}
        </div>
      </div>

      {handleError && handleError(name)}
    </div>
  );
};

export default DynamicRadioGroup;
